import { render } from "./ProductActions.vue?vue&type=template&id=79e6a9af&ts=true"
import script from "./ProductActions.vue?vue&type=script&lang=ts"
export * from "./ProductActions.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__